import React from 'react'
import { IssuesNotifications } from 'components/layout/Header/components/IssuesContainer/components/IssuesNotifications'
import { useEscalatedIssuesPolling } from 'components/layout/Header/components/IssuesContainer/hooks/useEscalatedIssuesPolling'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const useStyles = makeStyles(theme => ({
  root: {
    width: 'auto',

    [theme.breakpoints.up('lg')]: {
      width: 600,
    },
  },
  emptyState: {
    padding: theme.spacing(2),
    backgroundColor: brandColors.coolGray1,
    textAlign: 'center',
    border: `1px solid ${brandColors.coolGray4}`,
    borderRadius: '5px',
  },
  loading: {
    padding: theme.spacing(2),
    backgroundColor: brandColors.coolGray1,
    textAlign: 'center',
    border: `1px solid ${brandColors.coolGray4}`,
    borderRadius: '5px',
  },
}))

/**
 * Handles fetch and mutation logic for stateless children Issue list components
 */
const IssuesMenu = () => {
  const { data: escalatedIssues, issueCount, loading } = useEscalatedIssuesPolling()
  const classes = useStyles()
  return (
    <div data-test='IssuesMenu' className={classes.root}>
      {!loading && !!escalatedIssues?.length && (
        <IssuesNotifications escalatedIssues={escalatedIssues} issueCount={issueCount} />
      )}
      {loading && (
        <Box className={classes.loading}>
          <Spinner position='relative' />
        </Box>
      )}
      {!loading && escalatedIssues?.length === 0 && (
        <Box className={classes.emptyState}>
          <Typography color='textSecondary' variant='body2' align='center' component='div'>
            No issues
          </Typography>
        </Box>
      )}
    </div>
  )
}

export default IssuesMenu
